import { Table, Tag, Spin } from "antd";
import Header from "../_shared/components/Header";
import { useGetRolesQuery } from "../../../redux/api/scheduling";

export default function Roles() {
  const { data, isLoading } = useGetRolesQuery({});
  const roles = data?.results || data || [];

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Admin",
      dataIndex: "is_admin",
      key: "is_admin",
      render: (v: boolean) => v ? <Tag color="red">Yes</Tag> : "No",
    },
    {
      title: "Permissions",
      key: "permissions",
      render: (_: any, r: any) => (
        <div className="flex flex-wrap gap-1">
          {(r.permissions || []).map((p: any) => (
            <Tag key={p.id} color={p.can_edit ? "blue" : "default"}>
              {p.resource}: {[p.can_view && "V", p.can_create && "C", p.can_edit && "E", p.can_delete && "D"].filter(Boolean).join("")}
            </Tag>
          ))}
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4">
      <Header title="Roles & Permissions" />
      {isLoading ? (
        <Spin size="large" className="mt-10 mx-auto block" />
      ) : (
        <Table dataSource={roles} columns={columns} rowKey="id" size="small" />
      )}
    </div>
  );
}
